// extracted by mini-css-extract-plugin
export default {"card":"faq-card-module--card--YHFf2","number":"faq-card-module--number--70yVp","title":"faq-card-module--title--gx0q2","body":"faq-card-module--body--Scd0+"};